import { render, staticRenderFns } from "./ScenarioDetails.vue?vue&type=template&id=896abdd2&scoped=true&"
import script from "./ScenarioDetails.vue?vue&type=script&lang=js&"
export * from "./ScenarioDetails.vue?vue&type=script&lang=js&"
import style0 from "./ScenarioDetails.vue?vue&type=style&index=0&id=896abdd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896abdd2",
  null
  
)

export default component.exports